module.exports = __webpack_public_path__ + "static/media/powered_by_google_on_white_hdpi.60e8a832.png";